export class UserError extends Error {
  constructor (message: string) {
    super(message)
    this.name = 'UserError'
  }
}

/**
 * The replay file could not be read or played back. Marks the failure as
 * terminal so the error handler can swap the status line for the dedicated
 * error screen instead of offering a reconnect.
 */
export class ReplayOpenError extends UserError {
  constructor (message: string) {
    super(message)
    this.name = 'ReplayOpenError'
  }
}

/**
 * The replay could not be fetched at all — every attempt failed before any
 * server answered, so the network is down rather than the file being missing.
 */
export class ReplayNetworkError extends UserError {
  constructor (message: string) {
    super(message)
    this.name = 'ReplayNetworkError'
  }
}

/** The replay was recorded on a Minecraft version the player cannot open. */
export class ReplayVersionError extends UserError {
  constructor (message: string, readonly version: string, readonly maxVersion: string) {
    super(message)
    this.name = 'ReplayVersionError'
  }
}
